import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { NeokredNewLogo } from "../../../../utility/constants/assetsManager";
import {
  bgColor,
  colorWhite,
} from "../../../../utility/constants/colorManager";
import { STATUS_CODE_200 } from "../../../../utility/constants/valueConstants";
import { isPasswordValid } from "../../../../utility/PasswordValidation";
import ResizeListner from "../../../../utility/ResizeListner";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomPasswordInput from "../../../components/ui_comps/CustomPasswordInput";
import ImageComponent from "../ImageComponent";

function NewPassword({ email, otpRefCode, userId }) {
  const { height, width } = ResizeListner();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [rememberMe, setRememberMe] = useState("checked");
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [verified, setVerified] = useState("");
  const navigate = useNavigate();
  const onClickChangePassword = () => {
    setLoading(true);
    ApiRequestPost.forgotPasswordChange({
      confirmPassword,
      newPassword,
      userId,
      otpRefCode,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/login");
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    if (
      isPasswordValid(newPassword) &&
      confirmPassword &&
      confirmPassword === newPassword
    ) {
      setDisabled(false);
    } else setDisabled(true);
  }, [newPassword, confirmPassword]);

  return (
    <div
      style={{
        width,
        display: "flex",
        flexDirection: width > 650 ? "row" : "column",
        height: height,
      }}
    >
      {/* <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: width > 650 ? "flex" : "none",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: colorWhite,
        }}
      >
        <img
          src={NeokredNewLogo}
          style={{
            width: width * 0.35,
            minWidth: 150,
            maxWidth: 400,
          }}
        />
      </div> */}
      <ImageComponent />
      <div
        style={{
          width: width > 650 ? "50%" : "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: bgColor,
          flexDirection: "column",
          height,
        }}
      >
        <div
          style={{
            width: width > 650 ? "45%" : "70%",
            minWidth: width > 650 ? 300 : 250,
          }}
        >
          <p
            style={{
              fontWeight: "600",
              fontSize: 27,
              color: "#1A202C",
              margin: 0,
            }}
            className="roboto"
          >
            New Password
          </p>
          <p
            style={{
              fontSize: 15,
              color: "#2D3748",
              margin: 0,
              marginBottom: 20,
              lineHeight: "20px",
              marginTop: "5px",
            }}
            className="roboto"
          >
            Enter the new password and confirm it to change your password.
          </p>

          <div style={{ marginTop: "25px" }}>
            <p
              style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}
              className="roboto"
            >
              New Password<span style={{ color: "#FC3629" }}>*</span>
            </p>
            {/* <CustomInput
           
              inputStyles={{
                width: "100%",
                border: "1px solid #E8E8E8",
                boxShadow: "none",
                backgroundColor: "white",
                height: "45px",
              }}
              validator="password"
              type="input"
              maxLength={16}
            /> */}

            <CustomPasswordInput
              value={newPassword}
              onChange={setNewPassword}
              placeholder="New Password"
              isError={() => {}}
            />
          </div>

          <div style={{ marginTop: "15px" }}>
            <p
              style={{ margin: 0, color: "#4A5568", fontSize: "14px" }}
              className="roboto"
            >
              Confirm New Password<span style={{ color: "#FC3629" }}>*</span>
            </p>
            <CustomPasswordInput
              value={confirmPassword}
              onChange={setConfirmPassword}
              placeholder="Confirm New Password"
              isError={() => {}}
            />
          </div>

          <CustomButton
            loading={loading}
            title="Continue"
            styles={{
              width: "100%",
              borderRadius: "4px",
              marginTop: 40,
              height: "50px",
            }}
            textStyle={{
              color: colorWhite,
              fontSize: 15,
              fontWeight: "500",
            }}
            onClick={() => {
              onClickChangePassword();
            }}
            disabled={disabled}
          />

          {/* <p
            style={{
              fontSize: 10,
              color: "rgba(174, 174, 178)",
              marginTop: 10,
            }}
          >
            <IoMdInformationCircleOutline />
            Password must contain 8- 16 Characters including 1 UpperCase
            Alphabet, 1 LowerCase Alphabet, 1 number & 1 Special Character
          </p> */}
        </div>
      </div>
    </div>
  );
}

export default NewPassword;
